// extracted by mini-css-extract-plugin
module.exports = {"link":"FooterLanguageSwitcher_link__jLrEh","isActive":"FooterLanguageSwitcher_isActive__AhWK9"};